export const BasePlaceholders = {
	TEAM_MEMBER: "${teamMember}",
	USER: "${user}",
	ORGANIZATION: "${organization}"
} as const;

export const ScheduleCallPlaceholders = {
	...BasePlaceholders,
	DAY: "${day}",
	DATE: "${date}",
	TIME: "${time}",
	TIMEZONE: "${timezone}",
	SCHEDULED_DATE: "${scheduledDate}"
} as const;

export const RecordingRequestPlaceholders = {
	...BasePlaceholders
} as const;

export const LiveCallPlaceholders = {
	...BasePlaceholders
} as const;

export const GoogleReviewPlaceholders = {
	...BasePlaceholders
} as const;
